import {
  Component,
  OnInit,
  ViewChild,
  Input,
  ViewChildren,
  QueryList,
} from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import {
  Customer,
  CustomerAddress,
  CustomerPhone,
  ContactPerson,
} from '../../../models/customer.model';
import { AuthorizationBase } from 'src/app/shared/libraries/authorize-base';
import * as moment from 'moment';
import { LocationSwitchService } from 'src/app/shared/services/location-switch.service';
import { NgForm } from '@angular/forms';
import { ZipCodeValidator } from '../../../../shared/validators/zip-code.validator';
import { AlertService } from '../../../../core/alert.service';
import { CustomerManagementService } from '../../../services/customer.service';
import { CustomerPhoto } from '../../../../customer/models/customer.model';
import { Subscription } from 'rxjs';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe-decorator';
import { ContactFormComponent } from 'src/app/shared/components/customers/contact-form/contact-form.component';

@Component({
  selector: 'app-add-customer',
  templateUrl: './add-customer.component.html',
  styleUrls: ['./add-customer.component.scss'],
})
export class AddCustomerComponent extends AuthorizationBase implements OnInit {
  @ViewChild('customerForm', { static: true }) customerForm: NgForm;
  @ViewChild(ContactFormComponent)
  contactForm: ContactFormComponent;
  @Input()
  isIndividual: boolean = true;
  @Input() isEditMode: boolean = false;
  @Input() contactmodel: ContactPerson;
  @Input() model: Customer;

  isUSA: boolean = true;
  busy: boolean = false;
  addressmodel: CustomerAddress;
  phonemodel: CustomerPhone;
  countries = [];
  usStates = [];
  maxDate: string = moment(new Date()).format('YYYY-MM-DD');
  emailAddressValid: boolean = true;
  isShippingAddress: boolean = false;
  isDefaultSelected: boolean = false;
  shippingAddressCount: number = 0;
  validAddress: boolean = false;
  temporaryCountrySelected: string = 'United States';

  public locations: any[];
  zipCodeValidator: ZipCodeValidator;
  zipCodeError: boolean = false;

  customeraddresses: CustomerAddress[];
  processor: string;
  customerPhoto: any = 'assets/images/customer-photo.png';
  customerPhotoLoading: boolean = false;
  hasUpdates: boolean = false;

  customerContactNumbers: CustomerPhone[];

  @AutoUnsubscribe()
  private getAllCountries$: Subscription;
  @AutoUnsubscribe()
  private usaStates$: Subscription;
  @AutoUnsubscribe()
  private saveCustomer$: Subscription;
  @AutoUnsubscribe()
  private updateContactPerson$: Subscription;
  @AutoUnsubscribe()
  private addContactPerson$: Subscription;
  @AutoUnsubscribe()
  private addAddress$: Subscription;
  @AutoUnsubscribe()
  private addPhone$: Subscription;
  @AutoUnsubscribe()
  private updateCustomerPhoto$: Subscription;
  @AutoUnsubscribe()
  private loadLocations$: Subscription;
  @AutoUnsubscribe()
  saveCustomerContactWithAddress$: Subscription;

  constructor(
    private modalRef: NgbActiveModal,
    private alert: AlertService,
    public apiService: CustomerManagementService,
    private locationSwitchService: LocationSwitchService
  ) {
    super();

    this.model = new Customer();
    this.model.CustomerTypeId = 1;
    this.model.SalesTaxType = '%';
    this.addressmodel = new CustomerAddress();
    this.addressmodel.AddressType = 1;
    this.addressmodel.CountryId = 0;
    this.addressmodel.State = '';
    this.addressmodel.IsDefault = true;
    this.phonemodel = new CustomerPhone();
    this.phonemodel.PhoneType = 1;
    this.contactmodel = new ContactPerson();
    let locId = +locationSwitchService.getCurrentLocation();
    if (locId == 0) {
      locId = this.getCurrentLoginUser().LocationId;
    }

    this.model.LocationId = locId;
    this.zipCodeValidator = new ZipCodeValidator();
    this.customeraddresses = [];
    this.customerContactNumbers = [];
    this.processor = super.getPlatform().toString();
  }

  ngOnInit() {
    this.model.Photo =
      this.model.Photo == '' || this.model.Photo == null
        ? 'assets/images/customer-photo.PNG'
        : this.model.Photo;
    this.loadCountries();
    this.loadLocations();
    this.validAddress = this.isEditMode;
    this.hasUpdates = false;
    this.model.PaymentTerm = !this.model.PaymentTerm ? '' : this.model.PaymentTerm;
  }

  loadCountries() {
    return new Promise((resolve) => {
      this.getAllCountries$ = this.apiService
        .getAllCountries()
        .subscribe((resp: any[]) => {
          if (resp) {
            this.countries = resp;
            const usa = this.countries.find(
              (c) => c.CountryName === 'United States'
            );
            if (this.addressmodel.CountryId === 0) {
              this.addressmodel.CountryId = usa.Id;
              this.loadStates();
            }
          }
          resolve(resp);
        });
    });
  }

  loadStates() {
    this.usaStates$ = this.apiService.usaStates().subscribe((response: any) => {
      this.usStates = response;
    });
  }

  loadLocations() {
    this.loadLocations$ = this.locationSwitchService.locations.subscribe(
      (list) => {
        this.locations = list;
      }
    );
  }

  forceMaxDate(e) {
    if (e.target.value) {
      if (new Date(e.target.value) > new Date(e.target.max))
        e.target.value = e.target.max;
    } else {
      e.target.value = e.target.max;
    }
  }

  customerTypeChanged(event: any) {
    this.model.CustomerTypeId = event.target.value;
    this.isIndividual = event.target.value === '1' ? true : false;
  }

  countryChanged(event: any) {
    this.isUSA = event.target.value === '230' ? true : false;
    this.temporaryCountrySelected =
      event.target.options[event.target.options.selectedIndex].text;
  }

  save() {
    if (!this.isValidEmail() && this.isIndividual) return false;

    this.model.IsDeleted = false;
    this.model.CreatedDate = new Date();
    this.model.UpdatedBy = null;
    this.model.UpdatedDate = null;

    if(this.model.PaymentTerm === '') {
      this.model.PaymentTermCount = 0;
      this.model.PaymentTerm = null;
    }

    if (!this.isEditMode) {
      if (this.isIndividual && this.customeraddresses.length === 0) {
        this.addNewCustomerAddress();

        if (!this.validAddress) {
          return;
        }
      }

      this.model.MembershipNumber = 'TempNumber';
      this.model.MembershipStartDate = new Date();
      this.model.IsDeactivated = false;
      if(!this.isEditMode) {
        this.model.CreatedBy = Number.parseInt(super.userId().toString());
        this.model.UpdatedBy = Number.parseInt(super.userId().toString());
      } else {
        this.model.UpdatedBy = Number.parseInt(super.userId().toString());
      }
      this.model.Id = 0;
    }

    //check if Individual
    if (this.isIndividual) {
      this.model.BusinessName = null;
      this.model.BusinessNature = null;
    } else {
      this.model.FirstName = null;
      this.model.LastName = null;
      this.model.Birthday = null;
      this.model.JobTitle = null;
      this.model.About = null;
      this.model.EmailAddress = this.contactmodel.EmailAddress;
    }

    this.busy = true;
    this.saveCustomer$ = this.apiService
      .saveCustomer(this.model)
      .subscribe(async (res) => {
        if (res) {
          //add customer address
          await this.addAddress(res, null);
          //add phone
          await this.addPhone(res, null);
          //add contact person if business
          // if (!this.isIndividual) {
          //   this.addContactPerson(res);
          // }
          /**
           * Add Contact Persons in Business Type Customer.
           */

          if (
            !this.contactForm?.contactPersons.length &&
            this.contactForm?.customerForm.valid
          ) {
            this.contactForm.save();
          }

          if (this.contactForm?.contactPersons.length) {
            await this.addContacts(res);
          }

          let message = this.isEditMode
            ? 'Successfully updated customer record!'
            : 'Successfully created customer record!';
          this.alert.alertSuccess({
            title: 'Success',
            text: message,
          });
          this.busy = false;
          this.model.hasUpdates = true;
          this.modalRef.close(this.model.Id || res);
        }
      });
  }

  preventPureSpaces(e: any) {
    if (e.target.value) {
      if (e.target.value.trim().length == 0) {
        this.customerForm.controls[e.target.name].setValue(null);
      }
    }
  }

  addContactPerson(customerId: any) {
    if (this.contactmodel.Id) {
      this.contactmodel.UpdatedBy = Number.parseInt(super.userId().toString());
      this.updateContactPerson$ = this.apiService
        .updateContactPerson(this.contactmodel)
        .subscribe((res) => {
          if (res) {
          }
        });
    } else {
      this.contactmodel.BusinessCustomerId = customerId;
      this.contactmodel.IsMainContact = true;
      this.contactmodel.CreatedBy = this.model.CreatedBy;
      this.contactmodel.UpdatedBy = null;
      this.contactmodel.IsDeleted = false;
      this.addContactPerson$ = this.apiService
        .addContactPerson(this.contactmodel)
        .subscribe((res) => {
          if (res) {
            //add address
            this.addContactPersonAddress(customerId, res);
            // this.addAddress(null, res);
            //add phone
            this.addPhone(null, res);
          }
        });
    }
  }

  addContactPersonAddress(customerId, contactPersonId) {
    const contactPersonAddress = new CustomerAddress();
    contactPersonAddress.ContactPersonId = contactPersonId;
    contactPersonAddress.IsDefault = true;
    contactPersonAddress.CustomerId = customerId;
    this.addAddress$ = this.apiService
      .addAddress(contactPersonAddress)
      .subscribe((res: any) => {
        if (res) {
          console.log(res);
        }
      });
  }

  async addAddress(customerId: any, contactpersonId: any) {
    /*this.addressmodel.Id = 0;
    this.addressmodel.CustomerId = customerId;
    this.addressmodel.ContactPersonId = contactpersonId;
    this.addressmodel.IsDefault = true;
    this.addressmodel.CreatedBy = this.model.CreatedBy;
    this.addressmodel.UpdatedBy = null;
    this.addressmodel.IsDeleted = false;
    if (!this.isUSA){
      this.addressmodel.State = null;
    }
    this.apiService.addAddress(this.addressmodel).subscribe((res) => {
      if(res) {
        console.log(res);
      }
    });*/

    for (const customeraddress of this.customeraddresses) {
      customeraddress.County = null;
      customeraddress.CustomerId = customerId;
      customeraddress.ContactPersonId = contactpersonId;
      customeraddress.CreatedBy = Number(this.userId());
      
      // if (this.isDefaultSelected == false) {
      //   customeraddress.IsDefault = true;
      //   this.isDefaultSelected = true;
      // }

      await this.apiService.addAddress(customeraddress).toPromise();
    }
  }

  addressFieldRequiresValue() {
    return this.customeraddresses.length === 0;
  }

  addNewContactNumber() {
    const contactNumberItem = new CustomerPhone();
    contactNumberItem.PhoneNumber = this.phonemodel.PhoneNumber;
    contactNumberItem.PhoneType = this.phonemodel.PhoneType;

    this.customerContactNumbers.push(contactNumberItem);
    this.phonemodel.PhoneNumber = null;
    this.phonemodel.PhoneType = 1;
  }

  //added for transit changes
  //added for transit changes
  addNewCustomerAddress() {
    if (
      !this.addressmodel.AddressType ||
      !this.addressmodel.City ||
      !this.addressmodel.CountryId ||
      !this.addressmodel.StreetAddress ||
      !this.addressmodel.ZipCode
    ) {
      this.alert.alertWarning({
        title: 'Warning',
        text: 'Please provide complete address information.',
      });
    } else {
      this.zipCodeError = !this.zipCodeValidator.isValid(
        this.addressmodel.CountryId,
        this.addressmodel.ZipCode
      );
      if (this.zipCodeError) {
        this.alert.alertWarning({
          title: 'Warning',
          text: 'Invalid Zip Code.',
        });
        //return false;
      } else {
        let customeraddressitem = new CustomerAddress();
        customeraddressitem = this.addressmodel;
        customeraddressitem.Id = 0;
        customeraddressitem.CustomerId = 0;
        customeraddressitem.ContactPersonId = 0;
        customeraddressitem.IsDefault = this.addressmodel.IsDefault;
        if (customeraddressitem.IsDefault == true) {
          this.isDefaultSelected = true;
        }
        if (customeraddressitem.AddressType == 3) {
          this.isShippingAddress = true;
          this.shippingAddressCount += 1;
        }
        customeraddressitem.CreatedBy = this.model.CreatedBy;
        customeraddressitem.UpdatedBy = null;
        customeraddressitem.IsDeleted = false;

        customeraddressitem.County = this.temporaryCountrySelected;
        this.customeraddresses.push(customeraddressitem);

        //console.log(this.customeraddresses);
        this.addressmodel = new CustomerAddress();
        this.addressmodel.AddressType = 1;
        this.addressmodel.CountryId = 0;
        this.loadCountries();

        if (
          this.customeraddresses.length &&
          this.customeraddresses.length > 0
        ) {
          this.validAddress = true;

          if (
            this.model.LevelProcessing >= 2 &&
            this.isShippingAddress == true
          ) {
            this.validAddress = true;
          } else if (
            this.model.LevelProcessing >= 2 &&
            this.isShippingAddress == false
          ) {
            this.validAddress = false;
          }

          if (this.processor == 'tsys') {
            if (
              this.model.LevelProcessing >= 2 &&
              this.shippingAddressCount <= 0
            ) {
              this.addressmodel.AddressType = 3;
              this.alert.alertWarning({
                title: 'Warning',
                text: 'Shipping Address is Required for Level 2 or 3 Customers.',
              });
            }
          }
        } else {
          this.validAddress = false;
        }
      }
    }
  }

  async addPhone(customerId: any, contactpersonId: any) {
    let isDefault = true;
    if (this.customerContactNumbers.length > 0 && this.isIndividual) {
      for (const customerContactNumber of this.customerContactNumbers) {
        customerContactNumber.Id = 0;
        customerContactNumber.CustomerId = customerId;
        customerContactNumber.IsDefault = isDefault;
        customerContactNumber.CreatedBy = this.model.CreatedBy;
        customerContactNumber.UpdatedBy = null;
        customerContactNumber.IsDeleted = false;
        if (customerContactNumber.PhoneNumber) {
          await this.apiService.addPhone(customerContactNumber).toPromise();
          isDefault = false;
        }
      }
    } else {
      this.phonemodel.Id = 0;
      this.phonemodel.CustomerId = customerId;
      this.phonemodel.IsDefault = true;
      this.phonemodel.CreatedBy = this.model.CreatedBy;
      this.phonemodel.UpdatedBy = null;
      this.phonemodel.IsDeleted = false;
      if (this.phonemodel.PhoneNumber) {
        await this.apiService.addPhone(this.phonemodel).toPromise();
      }
    }
  }

  async addContacts(customerId: any) {
    for (const contact of this.contactForm.contactPersons) {
      contact.BusinessCustomerId = customerId;
      contact.Id = 0;
      for (const key in contact) {
        if (contact[key] === '' || contact[key] === null) {
          delete contact[key];
        }
      }
      await this.apiService.saveCustomerContactWithAddress(contact).toPromise();
    }
  }

  removeContactNumber(contactNumberIndex) {
    this.customerContactNumbers.splice(contactNumberIndex, 1);
  }

  remove(customeraddressitem, address_index) {
    if (this.processor == 'tsys') {
      if (customeraddressitem.AddressType == 3) {
        this.shippingAddressCount -= 1;
      }
      if (this.model.LevelProcessing >= 2 && this.shippingAddressCount <= 0) {
        this.validAddress = false;
        this.addressmodel.AddressType = 3;
        this.alert.alertWarning({
          title: 'Warning',
          text: 'Shipping Address is Required for Level 2 or 3 Customers.',
        });
      }
    }
    // remove from lists
    this.customeraddresses.splice(address_index, 1);
  }

  close() {
    this.modalRef.close();
  }

  isValidEmail() {
    const re =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    let emailAddress = this.isIndividual
      ? this.model.EmailAddress
      : this.contactmodel.EmailAddress;
    this.emailAddressValid = re.test(String(emailAddress).toLowerCase());

    return this.emailAddressValid;
  }

  onMobileNumberKeyup(event) {
    let formattedMobileNumber = event;

    if (event != '') {
      if (event.length > 2) {
        if (event.indexOf('(') < 0) {
          formattedMobileNumber = '(' + event[0] + event[1] + event[2] + ')';
        }
        if (event.length == 8) {
          formattedMobileNumber =
            formattedMobileNumber.slice(0, 5) +
            ' ' +
            formattedMobileNumber[5] +
            formattedMobileNumber[6] +
            formattedMobileNumber[7] +
            '-';
        }
        this.phonemodel.PhoneNumber = formattedMobileNumber;
      } else {
        this.phonemodel.PhoneNumber = event;
      }
    }
    //console.log(this.fieldvalue);
  }

  onLevelChange(levelValue) {
    if (levelValue == 2 || levelValue == 3) {
      this.addressmodel.AddressType = 3;
    } else {
      this.addressmodel.AddressType = 1;
    }
  }

  // for checking valid characters in PO Number
  checkSpecialChar(event) {
    var keyval;
    keyval = event.charCode;
    if (
      (keyval > 64 && keyval < 91) ||
      (keyval > 96 && keyval < 123) ||
      keyval == 8 ||
      keyval == 32 ||
      (keyval >= 48 && keyval <= 57)
    ) {
      return keyval;
    } else {
      this.alert.alertWarning({
        title: 'Warning!',
        text: 'Special characters are not allowed. Please use alphanumeric characters only.',
      });
    }
  }

  encodeImageFileAsURL(event: any) {
    if (event.target.files && event.target.files[0]) {
      let files = event.target.files;
      let reader = new FileReader();
      let file = files[0];

      reader.readAsDataURL(event.target.files[0]);

      reader.onload = (event: any) => {
        this.model.Photo = event.target.result;
        let customerPhoto = new CustomerPhoto();
        customerPhoto.Id = this.model.Id;
        customerPhoto.Image = event.target.result.replace(
          'data:image/jpeg;base64,',
          ''
        );
        this.customerPhotoLoading = true;
        this.updateCustomerPhoto$ = this.apiService
          .updateCustomerPhoto(customerPhoto)
          .subscribe((res: any) => {
            this.model.Photo = res.ImagePath;
            this.customerPhotoLoading = false;
            this.hasUpdates = true;
          });
      };
    }
  }

  isValidAddress() {
    if (this.isEditMode) return true;

    if (!this.isIndividual) return true;

    return this.validAddress || this.customerForm.form.valid;
  }
}
